import React, { ReactElement } from 'react';
import { Badge } from '@odin-labs/components';
import { classes } from './StepInfoTitle.style';

export type StepInfoTitleProps = {
  title?: string;
  subtitle?: string;
  stepNumberInfo?: {
    stepsCount: number;
    currentStep: number;
  };
  completeStep?: boolean;
  withBottomBorder?: boolean;
  hideOnMobile?: boolean;
  hideSubtitleOnMobile?: boolean;
};

export function StepInfoTitle(props: StepInfoTitleProps): ReactElement {
  const {
    title,
    subtitle,
    stepNumberInfo,
    completeStep,
    withBottomBorder,
    hideOnMobile,
    hideSubtitleOnMobile,
  } = props;
  const { stepsCount, currentStep } = stepNumberInfo ?? {};

  return (
    <div className={classes.container(withBottomBorder, hideOnMobile)}>
      <div className="odin-flex odin-flex-col odin-justify-between sm:odin-block sm:odin-space-y-2">
        <div className="odin-flex odin-flex-row-reverse odin-justify-between sm:odin-block sm:odin-space-y-2 odin-pb-2">
          {stepNumberInfo && !completeStep && (
            <div className="odin-shrink-0">
              <Badge
                size="lg"
                type="basic"
                color="blue"
                text={`${currentStep} of ${stepsCount}`}
              />
            </div>
          )}
          {completeStep && (
            <div className="odin-shrink-0">
              <Badge size="lg" type="basic" color="green" text="Complete" />
            </div>
          )}
          <div className="odin-space-y-2">
            <h2
              className={classes.title}
              data-testid="so-step-title-title-header"
            >
              {title}
            </h2>
          </div>
        </div>
        <div
          className={classes.subtitle(hideSubtitleOnMobile)}
          data-testid="so-step-title-subtitle-container"
        >
          {subtitle}
        </div>
      </div>
    </div>
  );
}
